"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSpamIssueNameTemplate = void 0;
/**
 * The account issue a CAN-SPAM hold of an email is recorded under: this
 * prefix and the email's id. A leaf with no imports, so the app can read the
 * name without the issue service, whose imports reach the database.
 */
exports.canSpamIssueNameTemplate = "email-can-spam-compliance-";
//# sourceMappingURL=can_spam_issue_name.js.map